import { render, staticRenderFns } from "./ConsoleHeader.vue?vue&type=template&id=48a8fcba"
import script from "./ConsoleHeader.vue?vue&type=script&lang=js"
export * from "./ConsoleHeader.vue?vue&type=script&lang=js"
import style0 from "./ConsoleHeader.vue?vue&type=style&index=0&id=48a8fcba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports